module.exports = __webpack_public_path__ + "img/img_5.aa5371e5.svg";